<div class="d-flex align-items-center" *ngIf="_taskRecord" [class.border-container]="borderEnabled">
  <div class="picture-container">
    <app-type-icon [ngStyle]="{'color': getColor()}" [icon]="_icon"></app-type-icon>

  </div>
  <div class="d-flex flex-column flex-grow-1 pr-1">
      <div class="d-flex align-items-center justify-content-between w-100">
      <a uiSref="#" class="text-break cursor-pointer mr-1" (click)="onTaskRecordClicked()">
        {{ cellTitle }}
      </a>
        <app-table-badge
          *ngIf="_stateObject"
          [showNotificationDot]="false"
          [badgeStyle]="_stateObject.badgeStyle"
          [iconClass]="_stateObject.iconClass"
          [text]="_stateObject.stringKey | translate">
      </app-table-badge>
      </div>
    <div class="text-break table-text-subtitle">{{ cellSubtitle }}</div>
  </div>
</div>
